export const MakeAnInternalUserIcon = () => {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M6.525 8.175C6.98063 8.175 7.35 7.80563 7.35 7.35C7.35 6.89436 6.98063 6.525 6.525 6.525C6.06937 6.525 5.7 6.89436 5.7 7.35C5.7 7.80563 6.06937 8.175 6.525 8.175Z"
				fill="black"
			/>
			<path
				d="M12.3 7.35C12.3 7.80563 11.9306 8.175 11.475 8.175C11.0194 8.175 10.65 7.80563 10.65 7.35C10.65 6.89436 11.0194 6.525 11.475 6.525C11.9306 6.525 12.3 6.89436 12.3 7.35Z"
				fill="black"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9 0.75C4.44365 0.75 0.75 4.44365 0.75 9C0.75 13.5563 4.44365 17.25 9 17.25C13.5563 17.25 17.25 13.5563 17.25 9C17.25 4.44365 13.5563 0.75 9 0.75ZM2.4 9C2.4 5.35492 5.35492 2.4 9 2.4C12.6451 2.4 15.6 5.35492 15.6 9C15.6 12.6451 12.6451 15.6 9 15.6C5.35492 15.6 2.4 12.6451 2.4 9Z"
				fill="black"
			/>
			<path
				d="M7.16268 10.9516C6.87669 10.603 6.36271 10.5483 6.00963 10.8308C5.65384 11.1154 5.59717 11.6359 5.88181 11.9916L5.9548 12.076C5.99373 12.1186 6.04724 12.1741 6.11544 12.238C6.25149 12.3656 6.44824 12.5288 6.7065 12.6902C7.22629 13.0151 7.9945 13.3313 9 13.3313C10.0055 13.3313 10.7737 13.0151 11.2935 12.6902C11.5518 12.5288 11.7485 12.3656 11.8846 12.238C11.9528 12.1741 12.0063 12.1186 12.0452 12.076L12.1192 11.9904C12.4038 11.6346 12.3462 11.1154 11.9904 10.8308C11.6373 10.5483 11.1233 10.603 10.8373 10.9516L10.8275 10.9626C10.8148 10.9764 10.791 11.0015 10.7561 11.0343C10.6859 11.1001 10.5732 11.1946 10.419 11.291C10.1138 11.4818 9.6445 11.6812 9 11.6812C8.3555 11.6812 7.88621 11.4818 7.581 11.291C7.42676 11.1946 7.31413 11.1001 7.24394 11.0343C7.20901 11.0015 7.18518 10.9764 7.17255 10.9626L7.16268 10.9516Z"
				fill="black"
			/>
		</svg>
	)
}
